import { axiosRequest } from '@/util/axios-request'

// 设置月度考勤周期
export const setAttendanceCycle = data =>
  axiosRequest({
    url: '/web/statistics/setAttendanceCycle',
    data
  })

// 获取月度考勤周期列表
export const getCycleList = data =>
  axiosRequest({
    url: '/web/statistics/cycleList',
    data
  })

// 设置月度汇总考勤的考勤规则
export const setAttendanceSetting = data =>
  axiosRequest({
    url: '/web/statistics/setAttendanceSetting',
    data
  })

// 获取月度考勤周期设置
export const getAttendanceCycle = data =>
  axiosRequest({
    url: '/web/statistics/getAttendanceCycle',
    data
  })

// 月度考勤统计
export const attendanceMonth = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonth',
    data
  })

// 导出月度考勤统计
export const attendanceMonthExcel = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonthExcel',
    data
  })
// 获取月度考勤汇总展示的字段
export const attendanceMonthField = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonthField',
    data
  })

// 考勤统计表格详情
export const attendanceDays = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonthDetail',
    data
  })
// 色值枚举
export const attendanceMonthColor = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonthColor',
    data
  })

// 更新月度考勤统计
export const attendanceMonthUpdate = data =>
  axiosRequest({
    url: '/web/statistics/attendanceMonthUpdate',
    data
  })

// 获取考勤设置
export const getAttendanceSetting = data =>
  axiosRequest({
    url: '/web/statistics/getAttendanceSetting',
    data
  })
